import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconSaveCaption } from '../../../base/icons/svg';
import { AbstractSaveCaptionButton, _abstractMapStateToProps } from './AbstractSaveCaptionButton';
/**
 * A button which starts/stops the transcriptions.
 */
class SaveCaptionButton extends AbstractSaveCaptionButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = "toolbar.accessibilityLabel.startSaveCaption";
        this.icon = IconSaveCaption;
        this.tooltip = 'toolbar.saveCaptionTooltip';
        this.label = 'toolbar.startSaveCaption';
        this.toggledLabel = 'toolbar.stopSaveCaption';
    }
}
export default translate(connect(_abstractMapStateToProps)(SaveCaptionButton));
